import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  Navigate,
} from "react-router-dom";
import "./App.css";
import HomePage from "./pages/HomePage";
import ProfilePage from "./pages/ProfilePage";
import EdvPage from "./pages/EdvPage";
import Home from "./pages/Home";

function getToken() {
  const tokenString = sessionStorage.getItem("token");
  const userToken = JSON.parse(tokenString);
  return userToken?.token;
}

function App() {
  const token = getToken();

  // check if token exists
  if (!token) {
    return (
      <div className="App">
        <main>
          <Router>
            <Routes>
              <Route path="*" element={<Home />} />
            </Routes>
          </Router>
        </main>
      </div>
    );
  }

  return (
    <Router>
      <div className="App">
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/evd" element={<EdvPage />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
